import type { ActiveAccountContextValue } from '@joyful/ui/app'
import {
  ActiveAccountContext,
  DatadogRumAccountIdentity,
  setActiveOrgSlugCookie,
  useMatchedRouteOrgSlug,
  useCurrentUser,
} from '@joyful/ui/app'
import type { ReactNode } from 'react'
import { useEffect } from 'react'
export interface ActiveOrgProviderProps {
  children: ReactNode
}

export function ActiveOrgProvider({ children }: ActiveOrgProviderProps) {
  const currentUser = useCurrentUser()
  const paramOrgSlug = useMatchedRouteOrgSlug()
  const activeAccount: ActiveAccountContextValue = paramOrgSlug
    ? (currentUser.accounts.find((account) => {
        return account.slug === paramOrgSlug
      }) ?? null)
    : null

  useEffect(() => {
    if (activeAccount) {
      setActiveOrgSlugCookie(activeAccount.slug)
    }
  }, [activeAccount])

  return (
    <ActiveAccountContext value={activeAccount}>
      <DatadogRumAccountIdentity />
      {children}
    </ActiveAccountContext>
  )
}
